// AtlasSheet.tsx — S1. The <900px bottom sheet AtlasBar opens: the SAME
// AtlasColumn, wrapped as a sheet. Closing it returns to the bar (the
// conversation/draft state lives on the channel passed in, mounted once at
// CockpitFrame, so nothing is lost by closing).
import type { AtlasChannel, CockpitOccupant } from '../lib/atlasChannel';
import { AtlasColumn } from './AtlasColumn';
import './AtlasSheet.css';

export interface AtlasSheetProps {
  channel: AtlasChannel;
  occupant?: CockpitOccupant;
  onClose: () => void;
}

export function AtlasSheet({ channel, occupant = 'atlas', onClose }: AtlasSheetProps) {
  return (
    <div class="atlas-sheet__backdrop" onClick={onClose}>
      <div
        class="atlas-sheet"
        role="dialog"
        aria-modal="true"
        aria-label={occupant === 'atlas' ? 'Atlas' : occupant.slice('builder:'.length)}
        onClick={(event) => event.stopPropagation()}
      >
        <AtlasColumn channel={channel} occupant={occupant} onClose={onClose} />
      </div>
    </div>
  );
}
